// extracted by mini-css-extract-plugin
export default {"panelContainer":"LpPanelContainer_panelContainer__1-PYK","borderBottom":"LpPanelContainer_borderBottom__fW0hb"};